var _rect, _rect2, _rect3, _rect4, _rect5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Connected50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 24.042,
    x: 18.568,
    y: 14.229,
    fill: "#3dd9eb",
    transform: "rotate(-45.001 21.75 26.25)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.075,
    height: 19.799,
    x: 10.085,
    y: 21.478,
    fill: "#3dd9eb",
    transform: "rotate(-45.001 16.622 31.378)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.468,
    height: 19.799,
    x: 19.139,
    y: 17.728,
    fill: "#00b3d7",
    transform: "rotate(-45.001 20.372 27.628)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.193,
    height: 4,
    x: 3.713,
    y: 36.19,
    fill: "#3dd9eb",
    transform: "rotate(-45.001 9.81 38.19)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 4,
    x: 11.561,
    y: 32.94,
    fill: "#00b3d7",
    transform: "rotate(-45.001 13.06 34.94)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 24.042,
    x: 23.068,
    y: 9.729,
    fill: "#6c19ff",
    transform: "rotate(-45.001 26.25 21.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.075,
    height: 19.799,
    x: 24.84,
    y: 6.723,
    fill: "#6c19ff",
    transform: "rotate(-45.001 31.377 16.623)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.468,
    height: 19.799,
    x: 26.393,
    y: 10.473,
    fill: "#2100c4",
    transform: "rotate(-45.001 27.627 20.373)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.193,
    height: 4,
    x: 32.093,
    y: 7.81,
    fill: "#6c19ff",
    transform: "rotate(-45.001 38.19 9.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 4,
    x: 33.44,
    y: 11.061,
    fill: "#2100c4",
    transform: "rotate(-45.001 34.94 13.061)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Connected50);
export default __webpack_public_path__ + "static/media/icons8-connected-50.3f8a191c05bac59f6435865220030434.svg";
export { ForwardRef as ReactComponent };